import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store({
    state: {
        isLandingView: true
    },
    mutations: {
        changeLandingview(state, shown) {
            state.isLandingView = shown
        }
    },

    actions: {
        hideLandingview({commit}) {
            commit('changeLandingview', false)
        }
    }
})